/** Ligne d'historique expirée (EARN passé ou statut backend). */
export function isPointMovementExpired(row) {
    if (row?.isExpired === true) return true;
    return String(row?.status || "").toLowerCase() === "expired";
}

export function isExpireMovementType(row) {
    return String(row?.type || "").toUpperCase() === "EXPIRE";
}

/** Mouvement compté pour le détail des lots encore valides. */
export function isActivePointsLotMovement(row) {
    if (!row || isExpireMovementType(row) || isPointMovementExpired(row)) return false;
    const type = String(row.type || "").toUpperCase();
    return (type === "EARN" || type === "ADJUST") && Number(row.points) > 0;
}

export function formatMovementTypeLabel(row) {
    if (isExpireMovementType(row)) return "Expiration";
    const type = String(row?.type || "–");
    if (isPointMovementExpired(row)) {
        const base = type.toUpperCase();
        if (base === "EARN" || base === "ADJUST") return `${base} (expiré)`;
    }
    return type;
}

export function formatMovementPointsText(row) {
    const pts = Number(row?.points ?? 0);
    if (isExpireMovementType(row)) {
        const abs = Math.abs(pts);
        return `Points expirés : ${pts <= 0 ? pts : `-${abs}`}`;
    }
    if (pts > 0) return `+${pts}`;
    return String(pts);
}

/** Couleur MUI pour la colonne variation. */
export function getMovementPointsColor(row) {
    if (isExpireMovementType(row)) return "warning.main";
    if (isPointMovementExpired(row)) return "text.secondary";
    const pts = Number(row?.points ?? 0);
    if (pts > 0) return "success.main";
    if (pts < 0) return "error.main";
    return "text.secondary";
}

export function getMovementChipSx(row) {
    if (isExpireMovementType(row)) {
        return {
            fontWeight: 600,
            fontSize: 11,
            borderRadius: 1,
            bgcolor: "#FEF3C7",
            color: "#B45309",
            borderColor: "#FCD34D",
        };
    }
    if (isPointMovementExpired(row)) {
        return {
            fontWeight: 600,
            fontSize: 11,
            borderRadius: 1,
            bgcolor: "#f1f5f9",
            color: "#64748b",
        };
    }
    return { fontWeight: 600, fontSize: 11, borderRadius: 1 };
}
